module.exports = __webpack_public_path__ + "img/6.ebeb4368.jpeg";